import { attr, hasMany } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const Producer = ApplicationRecord.extend({
  attrs: {
    title: attr(),
    description: attr(),
    video_url: attr(),
    images: hasMany({ type: 'recipes-producer_images' }),
  },
  static: {
    endpoint: '/producers',
    jsonapiType: 'recipes-producers',
  },
});

export default Producer;
